import React from 'react';
import {
  CreditIndicator,
  CreditIndicatorProps,
  UserInfo,
  UserInfoProps,
  useIsDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {Flex, View, Text, useTheme} from 'native-base';

export interface ProfileSummaryProps
  extends UserInfoProps,
    CreditIndicatorProps {
  onCtaPressed?: () => void;
  asOfDate: string;
  lastEarnedDate: string;
  expirationDate: string;
}

const ProfileSummary = (props: ProfileSummaryProps) => {
  const {
    accountId,
    currentLevel,
    currentTierInfo,
    fullName,
    nextTierInfo,
    allTiers,
    rewardCredits,
    tierCredits,
    tierInfo,
    asOfDate,
    lastEarnedDate,
    expirationDate,
  } = props;
  const theme = useTheme() as any;
  const {shuttleGray} = theme.colors;
  const isDesktop = useIsDesktop();

  return (
    <Flex bgColor="white" overflow="hidden" shadow={isDesktop ? 0 : undefined}>
      <View padding={5}>
        <UserInfo
          accountId={accountId}
          collapsed={false}
          currentLevel={currentLevel}
          fullName={fullName}
          tierInfo={tierInfo}
        />
        <CreditIndicator
          currentLevel={currentLevel}
          currentTierInfo={currentTierInfo}
          nextTierInfo={nextTierInfo}
          allTiers={allTiers}
          rewardCredits={rewardCredits}
          tierCredits={tierCredits}
        />
        {lastEarnedDate && expirationDate ? (
          <>
            <Text
              paddingTop={isDesktop ? '8px' : undefined}
              fontFamily="body"
              fontSize={isDesktop ? '14px' : '11px'}
              color={shuttleGray}
              textAlign={isDesktop ? 'center' : undefined}>
              Last credits earned:{' '}
              <Text fontWeight={600}>{lastEarnedDate}</Text>
            </Text>
            <Text
              paddingTop={'8px'}
              fontFamily="body"
              fontSize={isDesktop ? '14px' : '11px'}
              color={shuttleGray}
              textAlign={isDesktop ? 'center' : undefined}>
              Earn more Reward Credits before{' '}
              <Text fontWeight={600}>{expirationDate}</Text> to retain your
              balance
            </Text>
          </>
        ) : null}
      </View>
    </Flex>
  );
};

export default ProfileSummary;
